import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ShopPage from "@/pages/shop/page";
import ProductPage from "@/pages/product/page";
import CartPage from "@/pages/cart/page";
import CheckoutPage from "@/pages/checkout/page";
import OrderConfirmationPage from "@/pages/order-confirmation/page";
import SearchPage from "@/pages/search/page";
import ContactPage from "@/pages/contact/page";
import FAQPage from "@/pages/faq/page";
import PrivacyPage from "@/pages/privacy/page";
import TermsPage from "@/pages/terms/page";
import TrackOrderPage from "@/pages/track-order/page";
const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/shop", element: <ShopPage /> },
  { path: "/product/:id", element: <ProductPage /> },
  { path: "/cart", element: <CartPage /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/order-confirmation", element: <OrderConfirmationPage /> },
  { path: "/search", element: <SearchPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/track-order", element: <TrackOrderPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
